import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=7e5b9c30&"
import script from "./AdminHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports